/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Update_CurrentInputs */

const en_us2_profile_update_current = /** @type {(inputs: Profile_Update_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're on the latest version.`)
};

const pt_br2_profile_update_current = /** @type {(inputs: Profile_Update_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você já está na versão mais recente.`)
};

const es_419_profile_update_current = /** @type {(inputs: Profile_Update_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya tienes la versión más reciente.`)
};

const pt_pt2_profile_update_current = /** @type {(inputs: Profile_Update_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já tens a versão mais recente.`)
};

const fr_fr2_profile_update_current = /** @type {(inputs: Profile_Update_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu as la dernière version.`)
};

const de_de2_profile_update_current = /** @type {(inputs: Profile_Update_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast die neueste Version.`)
};

const it_it2_profile_update_current = /** @type {(inputs: Profile_Update_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai già la versione più recente.`)
};

/**
* | output |
* | --- |
* | "You're on the latest version." |
*
* @param {Profile_Update_CurrentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_update_current = /** @type {((inputs?: Profile_Update_CurrentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Update_CurrentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_update_current(inputs)
	if (locale === "es-419") return es_419_profile_update_current(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_update_current(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_update_current(inputs)
	if (locale === "de-DE") return de_de2_profile_update_current(inputs)
	if (locale === "it-IT") return it_it2_profile_update_current(inputs)
	return en_us2_profile_update_current(inputs)
});
export { profile_update_current as "profile.update_current" }